import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../configuration/app.config';

import * as _ from 'underscore';
import { CacheMode, CacheTypes } from '../service.base';

import * as moment from 'moment';

@Injectable()
export class RequestCache {

  constructor(private config: AppConfig) { }

  cache = new Map();

  get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.urlWithParams;

    const cacheMode = this.GetCache(req.headers);
    if (!this.NotExluded(url) || cacheMode.mode === CacheTypes.NoCache.mode) {
      return;
    }

    if (cacheMode.mode === 'public') {
      console.info('public caching is not supported');
      return;
    }

    const cached = this.cache.get(url);

    if (!cached) {
      return undefined;
    }

    const isExpired = cached.lastRead < (Date.now() - cacheMode.maxAge * 1000);
    return isExpired ? undefined : cached.response;
  }

  private NotExluded(url: string) {
    if (this.config.Cache) { return _.every(this.config.Cache.Excludes, (partialUrl) => url.indexOf(partialUrl) === -1); }
    return false;
  }

  put(req: HttpRequest<any>, response: HttpResponse<any>): void {
    const url = req.url;

    const cacheMode = this.GetCache(req.headers);
    if (!this.NotExluded(url) || cacheMode.mode === CacheTypes.NoCache.mode) {
      return;
    }
    if (cacheMode.mode === 'public') {
      console.info('public caching is not supported');
      return;
    }

    const entry = { url, response, lastRead: moment(), maxAge: cacheMode.maxAge };
    this.cache.set(url, entry);

    const expiredEntities = [];
    this.cache.forEach(expiredEntry => {
      if (expiredEntry.lastRead.add(expiredEntry.maxAge, 'seconds') < moment()) {
        expiredEntities.push(expiredEntry.url);
      }
    });

    if (expiredEntities.length > 0) {
      console.groupCollapsed('Cache');
      expiredEntities.forEach((ee) => {
        console.info('Remove' + ee);
        this.cache.delete(ee);
      });
      console.groupEnd();
    }
  }

  private GetCache(headers: HttpHeaders): CacheMode {

    if (headers.has('Cache-Control')) {
      const controlHeader = headers.get('Cache-Control');
      return CacheMode.Reconstruct(controlHeader);
    }

    return CacheTypes.NoCache;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/cache/request.cache.service.ts